<div class="modal-dialog">
    <div class="modal-header">
        <div class="heading">
            <div class="heading-text">{{ 'order.confirmOrderCancellation' | translate }}</div>
        </div>
        <button mat-icon-button class="button-icon" (click)="closePopup(null)">
            <mat-icon class="close-icon">close</mat-icon>
        </button>
    </div>
    <div class="modal-body">
        <div class="paragraph">
            <div class="paragraph-text">{{ 'order.orderCancellation' | translate }} {{this.orderNumber}}?</div>
        </div>
    </div>
    <drop-down
            ngDefaultControl
            [label]="'reasonCode.reasonCode' | translate"
            [data]="reasonCodeTypes"
            [formControl]="reasonCodeControl"
            [multiple]="false">
    </drop-down>
    <div class="modal-footer">
        <button class="right-footer-actions" mat-button
                (click)="closePopup(this.reasonCodeControl.value)">
                {{ 'orderDetail.cancelOrder' | translate }}
        </button>
    </div>
</div>
